import { Button, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import Toptag from '../../components/topTag/Toptag'
import API, { BASE_URL } from '../../Api'
import { BackPaper } from '../../components/Styles'
import { getRequest, patchRequest, postRequest } from '../../ApiFunction'
import toast from 'react-hot-toast'
import { useNavigate, useParams } from 'react-router-dom'

const EditCompany = () => {

    const nav = useNavigate()

    const [obj, setObj] = useState({
        name: "",
        count: 0
    });

    function onChange(e) {
        if (e.target.name === 'count') {
            if (!isNaN(e.target.value)) {
                setObj({
                    ...obj,
                    [e.target.name]: e.target.value.trim()
                })
            }
        } else {
            setObj({
                ...obj,
                [e.target.name]: e.target.value
            })
        }
    }

    const { id } = useParams();

    async function submitDetails() {
        try {
            const { data } = await patchRequest(API.UPDATE_COMPANY + id, obj);
            if (data.status) {
                toast.success(data.message)
                nav(-1)
            } else {
                toast.error(data.message)
            }
        } catch (err) {
            toast.error(err)
        }
    }

    async function getDetails() {
        try {
            const { data } = await getRequest(API.COMPANY_DETAILS + id, obj);
            if (data.status) {
                // toast.success(data.message)
                setObj(data.data)
                // nav(-1)
            } else {
                toast.error(data.message)
            }
        } catch (err) {
            toast.error(err)
        }
    }

    useEffect(() => {
        getDetails()
    }, [id])

    return (

        <>
            <Toptag />
            <BackPaper>
                <div className='d-flex justify-content-between align-items-center p-2 mb-3'>
                    <div className='detailHeading'>Edit Company</div>
                </div>

                <div className='row form-handler'>
                    <div className='col-md-6 mb-3'>
                        <TextField id="outlined-basic" name="name" value={obj.name} onChange={onChange} label="Company name" variant="outlined" />
                    </div>
                    <div className='col-md-6 mb-3'>
                        <TextField id="outlined-basic" name="count" value={obj.count} onChange={onChange} label="Users limit" variant="outlined" />
                    </div>
                    <div className='col-md-6 mb-3'>
                        <Button variant="contained" style={{ color: "white !important" }} onClick={submitDetails}>Submit</Button>
                    </div>
                </div>

            </BackPaper>
        </>
    )
}

export default EditCompany